import type { Report } from './types';

export const reports: Report[] = [
  {
    no: "БТ-2026-0044", titleKo: "메스암페타민 정량 감정 보고서", titleMn: "Метамфетамины тоо хэмжээний шинжилгээний тайлан",
    caseNo: "ХД-2026-0142", author: "Н.Болормаа", date: "2026-03-27", security: "2급", tool: "GC-MS · FTIR · Raman (785 nm)",
    status: "rpApproved", type: "ftDrugQuant",
    overviewKo: "바양주르흐 사건에서 압수된 결정성 백색분말 시료(ЭМ-2026-0311, 총 182.4g, 24개 소분)에 대한 정성·정량 감정을 수행함. GC-MS 및 라만 분광 분석 결과 메스암페타민 양성으로 확인되었으며, 평균 순도 78.2%로 측정됨.",
    overviewMn: "Баянзүрх дүүргийн хэргээс хураасан талст цагаан нунтаг дээж (ЭМ-2026-0311, нийт 182.4г, 24 хэсэг)-д чанарын болон тоо хэмжээний шинжилгээ хийв. GC-MS болон Раман спектрийн шинжилгээгээр метамфетамин эерэг, дундаж цэвэршилт 78.2% тогтоогдов.",
    findings: [
      { sev: "high", ko: "메스암페타민(MA) 양성 — GC-MS 머무름시간·질량스펙트럼 표준품 일치", mn: "Метамфетамин (MA) эерэг — GC-MS-ийн үзүүлэлт стандарттай тохирсон" },
      { sev: "high", ko: "평균 순도 78.2% — 고순도 결정형 (유통 직전 단계 추정)", mn: "Дундаж цэвэршилт 78.2% — өндөр цэвэршилттэй талст хэлбэр" },
      { sev: "mid", ko: "희석제 카페인·MSM 검출 (합 12.4%)", mn: "Шингэлэгч кофеин, MSM илрэв (нийт 12.4%)" },
      { sev: "info", ko: "24개 소분 시료 간 순도 편차 ±3.1% — 동일 공급원 추정", mn: "24 дээжийн цэвэршилтийн зөрүү ±3.1% — нэг эх үүсвэр" },
    ],
    artifacts: [
      { icon: "bi-capsule", labelKo: "검출 성분", labelMn: "Илэрсэн бодис", count: "MA" },
      { icon: "bi-graph-up", labelKo: "평균 순도", labelMn: "Цэвэршилт", count: "78.2%" },
      { icon: "bi-stack", labelKo: "분석 시료", labelMn: "Дээж", count: "24" },
      { icon: "bi-rulers", labelKo: "정량 결과", labelMn: "Тоо хэмжээ", count: "182.4g" },
    ],
    chartTitleKo: "검출 성분 구성", chartTitleMn: "Илэрсэн бодисын бүрэлдэхүүн", chartUnitKo: "%", chartUnitMn: "%",
    contacts: [
      { name: "메스암페타민 (MA)", count: 78.2 },
      { name: "수분·기타", count: 9.4 },
      { name: "카페인", count: 8.1 },
      { name: "MSM", count: 4.3 },
    ],
    conclusionKo: "압수 시료는 「향정신성의약품의 관리에 관한 법률」상 1급 메스암페타민으로 확인됨. 고순도(78.2%) 결정형으로 유통 직전 단계로 판단되며, 희석제 구성과 순도 편차로 보아 단일 공급원에서 소분된 것으로 추정됨. 정량 결과(182.4g)는 양형 산정 기초자료로 활용 가능함.",
    conclusionMn: "Хураасан дээж нь сэтгэцэд нөлөөт бодисын тухай хуулийн дагуу I зэрэглэлийн метамфетамин болох нь тогтоогдов. Өндөр цэвэршилттэй (78.2%) талст хэлбэртэй тул түгээхийн өмнөх шат гэж үзэж байна. Тоо хэмжээ (182.4г) нь ялын хэмжээ тогтооход үндэслэл болно.",
  },
  {
    no: "БТ-2026-0042", titleKo: "Galaxy S24 메시지·통신 분석 보고서", titleMn: "Galaxy S24 зурвас, харилцааны шинжилгээний тайлан",
    caseNo: "ХД-2026-0142", author: "Ж.Тэмүүжин", date: "2026-04-02", security: "2급", tool: "Cellebrite UFED · Magnet AXIOM",
    status: "rpApproved", type: "ftMessages",
    overviewKo: "피의자 Б.Тэмүүлэн 소유 Galaxy S24 단말에서 추출한 메시지 및 통신 데이터를 분석함. SNS 비밀 채팅방을 통한 메스암페타민 판매 정황과 공범 간 연락 관계가 다수 확인됨.",
    overviewMn: "Сэжигтэн Б.Тэмүүлэнгийн Galaxy S24 утаснаас гаргаж авсан зурвас, харилцааны өгөгдлийг шинжлэв. Нууц чатаар метамфетамин худалдсан болон хамтран гүйцэтгэгчидтэй холбогдсон нотолгоо олдсон.",
    findings: [
      { sev: "high", ko: "비밀 채팅방 3개에서 거래 추정 메시지 214건 확인", mn: "3 нууц чатаас гүйлгээтэй холбоотой 214 зурвас илрүүлэв" },
      { sev: "high", ko: "공범 Г.Сараннэмэх와 47회 통화 기록 확인", mn: "Хамтрагч Г.Сараннэмэхтэй 47 удаа ярьсан бичлэг олдов" },
      { sev: "mid", ko: "삭제된 거래 장부 이미지 12건 복구", mn: "Устгасан гүйлгээний дэвтрийн зураг 12-г сэргээв" },
      { sev: "info", ko: "위치 이력상 바양주르흐 13구역 반복 방문 확인", mn: "Байршлын түүхээс Баянзүрх 13-р хороонд давтан очсон нь тогтоогдов" },
    ],
    artifacts: [
      { icon: "bi-chat-dots", labelKo: "분석 메시지", labelMn: "Зурвас", count: "1,284" },
      { icon: "bi-telephone", labelKo: "통화기록", labelMn: "Дуудлага", count: "342" },
      { icon: "bi-geo-alt", labelKo: "위치정보", labelMn: "Байршил", count: "78" },
      { icon: "bi-trash", labelKo: "복구 파일", labelMn: "Сэргээсэн", count: "56" },
    ],
    contacts: [
      { name: "Г.Сараннэмэх", count: 47 },
      { name: "Ц.Билгүүн", count: 31 },
      { name: "Т.Идэрбат", count: 24 },
      { name: "미상 번호 (8808···)", count: 18 },
      { name: "Д.Оюунчимэг", count: 9 },
    ],
    conclusionKo: "추출·분석된 디지털 증거는 피의자가 조직적 마약 유통에 가담하였음을 뒷받침하며, 공범 Г.Сараннэмэх 및 총책 Т.Идэрбат와의 연락 관계를 입증함. 복구된 거래 장부는 추가 기소 자료로 활용 가능함.",
    conclusionMn: "Гаргаж авсан дижитал нотлох баримт нь сэжигтэн зохион байгуулалттай мансууруулах бодис түгээхэд оролцсныг нотолж, хамтрагч Г.Сараннэмэх, удирдагч Т.Идэрбаттай холбогдсоныг тогтоов. Сэргээсэн гүйлгээний дэвтэр нэмэлт яллах нотолгоо болно.",
  },
  {
    no: "БТ-2026-0039", titleKo: "Lenovo 노트북 삭제파일 복구 보고서", titleMn: "Lenovo компьютерийн устгасан файл сэргээх тайлан",
    caseNo: "ХД-2026-0121", author: "Ж.Тэмүүжин", date: "2026-03-28", security: "2급", tool: "Magnet AXIOM",
    status: "rpReview", type: "ftRecovery",
    overviewKo: "압수된 Lenovo 노트북에서 삭제된 회계 파일 및 암호화 문서를 복구·분석함.",
    overviewMn: "Хураасан Lenovo компьютерээс устгасан санхүүгийн файл, шифрлэсэн баримтыг сэргээж шинжлэв.",
    findings: [
      { sev: "high", ko: "엑셀 거래 장부 4개 복구 — 총 ₮2.1억 규모 거래 기록", mn: "Excel гүйлгээний 4 дэвтэр сэргээв — нийт 210 сая төгрөгийн бичилт" },
      { sev: "mid", ko: "암호화 ZIP 1개 — 복호화 진행 중", mn: "Шифрлэсэн ZIP 1 — тайлж байна" },
      { sev: "info", ko: "브라우저 기록상 암호화폐 거래소 접속 이력", mn: "Хөтчийн түүхэд криптовалютын биржийн хандалт" },
    ],
    artifacts: [
      { icon: "bi-file-earmark-recover", labelKo: "복구 파일", labelMn: "Сэргээсэн", count: "318" },
      { icon: "bi-file-spreadsheet", labelKo: "거래장부", labelMn: "Дэвтэр", count: "4" },
      { icon: "bi-globe", labelKo: "방문 기록", labelMn: "Хандалт", count: "1,902" },
      { icon: "bi-lock", labelKo: "암호화 파일", labelMn: "Шифрлэсэн", count: "1" },
    ],
    contacts: [
      { name: "Binance (web)", count: 38 },
      { name: "Telegram Desktop", count: 27 },
      { name: "미상 메일주소", count: 14 },
    ],
    conclusionKo: "복구된 회계 자료는 자금 흐름 추적의 핵심 증거이며, 암호화폐 거래소 접속 이력은 수익 은닉 정황을 시사함.",
    conclusionMn: "Сэргээсэн санхүүгийн материал нь мөнгөн урсгал мөрдөх гол нотолгоо бөгөөд криптобиржийн хандалт орлого нуусан байж болзошгүйг илтгэнэ.",
  },
];
